/**
 * src/api/convenios.js
 * Los Convenios Marco soportados. UNA fuente.
 *
 * Antes cada pantalla llevaba su copia: `Clientes.jsx` y `Onboarding.jsx`
 * tenían la misma lista con las etiquetas escritas a mano, y el backend una
 * tercera. Es el §4 de docs/ERRORES_RECURRENTES.md, y se coló porque la guarda
 * solo buscaba «Convenio Marco» mientras las listas decían «Alimentos».
 *
 * El endpoint es público porque el wizard de alta corre sin sesión: son tiendas
 * públicas del Mercado Público, sin dato de negocio ni personal.
 */
import api from './client'

export const getConvenios = () =>
  api.get('/convenios').then(r => r.data?.convenios ?? [])
